/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Tier_YearlyInputs */

const en_pricing_tier_yearly = /** @type {(inputs: Pricing_Tier_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yearly`)
};

const es_pricing_tier_yearly = /** @type {(inputs: Pricing_Tier_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anual`)
};

/**
* | output |
* | --- |
* | "Yearly" |
*
* @param {Pricing_Tier_YearlyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_tier_yearly = /** @type {((inputs?: Pricing_Tier_YearlyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Tier_YearlyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_tier_yearly(inputs)
	return en_pricing_tier_yearly(inputs)
});